// Application Configuration
// All environment-dependent values should come from .env

export const CONFIG = {
  APP_NAME: 'HiWAY',
  APP_TAGLINE: 'Eat Fresh on Every Journey',
  
  // API Configuration (for future backend)
  API_BASE_URL: process.env.REACT_APP_BACKEND_URL || '',
  API_VERSION: 'v1',
  
  // Google Maps
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  
  // Default coordinates (Manesar, Haryana - Highway hub)
  DEFAULT_LOCATION: {
    lat: 28.4595,
    lng: 77.0266,
  },
  
  // Geolocation settings
  GEOLOCATION_OPTIONS: {
    enableHighAccuracy: true,
    timeout: 15000,
    maximumAge: 60000,
  },
};

// Screen names for navigation
export const SCREENS = {
  SPLASH: 'splash',
  AUTH: 'auth',
  HOME: 'home',
  MAP: 'map',
  TRIP_PLANNER: 'tripPlanner',
  FOOD: 'food',
  FUEL: 'fuel',
  WASHROOM: 'washroom',
  STAY: 'stay',
  EV_CHARGING: 'evCharging',
  EMERGENCY: 'emergency',
  ROADSIDE_ASSISTANCE: 'roadsideAssistance',
  RESTAURANT: 'restaurant',
  BOOKING: 'booking',
  BREAKFAST: 'breakfast',
  BREAKFAST_CHECKOUT: 'breakfastCheckout',
  PROFILE: 'profile',
  MY_TRIPS: 'myTrips',
  MY_ORDERS: 'myOrders',
  PAYMENTS: 'payments',
  SUPPORT: 'support',
  SETTINGS: 'settings',
};

// Service types on home screen
export const SERVICE_TYPES = {
  FOOD: 'food',
  FUEL: 'fuel',
  WASHROOM: 'washroom',
  STAY: 'stay',
  EV_CHARGING: 'evCharging',
  EMERGENCY: 'emergency',
  ROADSIDE_ASSISTANCE: 'roadsideAssistance',
};
